import { React, useCallback, useEffect, useState } from "react";
import { isMobile, isDesktop } from "react-device-detect";
import Slider from "react-slick";
import "./Layout9.css";
import {
  withRouter,
  importAll,
  SVGIcons,
  ImgIcons,
  getcolors,
  VirsionCheck,
  Decrypt,
} from "../../Helpers/Common";
import { Showdetailspopup } from "../Showdetailspopup/Showdetailspopup";
import Hover from "../OnHoverDetails/Hover";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Pagination, Navigation } from "swiper";
var ImageData = "";
var SVGIcon = "";
ImgIcons().then((result) => (ImageData = result));
SVGIcons().then((resultData) => (SVGIcon = resultData));

export function Layout9(props) {
  const [showdetails, setshowdetails] = useState(false);
  const [details, setdetails] = useState(false);
  // const [showShimmer, setShowShimmer] = useState(true);

  // const handleTimeout = useCallback(() => {
  //   setShowShimmer(false);
  // }, []);

  // useEffect(() => {
  //   // const timer = setTimeout(() => {
  //     setShowShimmer(false);
  //   // }, 1000);

  //   // return () => {
  //   //   clearTimeout(timer);
  //   // };
  // }, [handleTimeout]);

  function showdetailspop(data) {
    setshowdetails(true);
    setdetails(data);
  }

  let Closepopup = () => {
    setshowdetails(false);
  };

  var settings = {
    slidesToShow: 3,
    centerMode: true,
    arrows: false,
    variableWidth: true,
    arrows: false,
    dots: false,
    swipeToSlide: true,
    speed: 200,
    infinite: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 650,
        settings: {
          slidesToShow: 1,
          centerPadding: "5px",
        },
      },
    ],
  };

  const headerText = () => {
    return (
      <>
        {/* {showShimmer ? (
          <div className="line linedesk linehead" />
        ) : ( */}
        <>
          <div className="head">
            <img src={ImageData["award-winning.png"]} alt="DocuBay" />
            <h3>
              {props.title.display_title}
              <span className="red">{props.title.display_title_sufix}</span>
            </h3>
          </div>
        </>
        {/* )} */}
      </>
    );
  };

  return (
    <>
      <section className="mb-0">
        {window.innerWidth > 768 ?
          <>
            <div className="temp25 dD-block">
              {headerText()}
              <div className="temp25-area">
                <Swiper
                  navigation={{
                    prevEl: ".slick-prev",
                    nextEl: ".slick-next",
                  }}
                  slidesPerView={2.4}
                  spaceBetween={16}
                  freeMode={true}
                  loop={false}
                  // loopFillGroupWithBlank={true}
                  centeredSlides={false}
                  breakpoints={{
                    650: {
                      slidesPerView: 1,
                    },
                    850: {
                      slidesPerView: 5.3,
                    },
                  }}
                  modules={[Navigation, FreeMode, Pagination]}
                  className="temp25-slider"
                >
                  <div className="side-overlay-L dD-block"></div>
                  <button
                    className="slick-prev slick-arrow"
                    type="button"
                    aria-label="Previous"
                  />
                  {props.Layout1.map((data, index) => {
                    return (
                      <SwiperSlide key={index} className="temp25-item">
                        {/* {showShimmer ? (
                          <img src={ImageData["placeholder2.png"]} alt="shimmer" className="shimmer" />
                        ) : ( */}
                        <>
                          <Hover
                            data={data}
                            silverIcon={props.silverIcon}
                            goldenIcon={props.goldenIcon}
                          />
                          <div className="temp25-itemColor">
                            <img src={data.vertical_banner.small} alt="DocuBay" />
                            {data.premium && data.original_tag ? (
                              <div className="premium-red">
                                <img
                                  src={props.goldenIcon}
                                  style={{
                                    width: "1.7rem",
                                    marginRight: "3px",
                                    marginBottom: "2px",
                                  }}
                                />
                              </div>
                            ) : null}
                            {data.premium && !data.original_tag ? (
                              <div className="premium-red">
                                <img
                                  src={props.silverIcon}
                                  style={{
                                    width: "1.7rem",
                                    marginRight: "3px",
                                    marginBottom: "2px",
                                  }}
                                />
                              </div>
                            ) : null}
                          </div>
                          <div className="bay-title">{data.keywords}</div>
                          {/* {data.premium && !data.original_tag ? (
                      <div className="premium-red">
                        <img
                          src="https://dbcms.docubay.com/media-upload/1691135448-golden-d-new.png"
                          style={{
                            width: "1rem",
                            "margin-bottom": "5px",
                            "border-radius": "0px",
                            "margin-rigth":"10px"
                          }}
                        />
                      </div>
                    ) : null} */}
                        </>
                        {/* )} */}
                      </SwiperSlide>
                    );
                  })}
                  <SwiperSlide></SwiperSlide>
                  <div className="side-overlay-R dD-block"></div>
                  <button
                    className="slick-next slick-arrow"
                    type="button"
                    aria-label="Next"
                  />
                </Swiper>
              </div>
            </div>
          </>
          :
          <>
            <div className="temp25 dD-none">
              {headerText()}
              {/* {showShimmer ? (
                <img src={ImageData["placeholder2.png"]} alt="shimmer" className="shimmer" style={{ display: "block", margin: "0 auto", width: "90%" }} />
              ) : ( */}
              <>
                <div className="temp25-area">
                  <div className="temp25-slider">
                    <Slider {...settings}>
                      {props.Layout1.map((data, index) => {
                        return (
                          <div className="temp25-sliderItem" key={index}>
                            <>
                              <div
                                onClick={() => {
                                  showdetailspop(data);
                                }}
                              >
                                <div className="temp25-item">
                                  <div className="temp25-itemColor">
                                    <img
                                      src={data.vertical_banner.small}
                                      alt="DocuBay"
                                    />
                                    {data.premium && data.original_tag ? (
                                      <div className="premium-red">
                                        <img
                                          src={props.goldenIcon}
                                          style={{
                                            width: "1.3rem",
                                            marginRight: "3px",
                                            marginBottom: "2px",
                                          }}
                                        />
                                      </div>
                                    ) : null}
                                    {data.premium && !data.original_tag ? (
                                      <div className="premium-red">
                                        <img
                                          src={props.silverIcon}
                                          style={{
                                            width: "1.3rem",
                                            marginRight: "3px",
                                            marginBottom: "2px",
                                          }}
                                        />
                                      </div>
                                    ) : null}
                                  </div>
                                  <div className="bay-title">{data.keywords}</div>
                                </div>
                              </div>
                            </>
                          </div>
                        );
                      })}
                    </Slider>
                  </div>
                </div>
              </>
              {/* )} */}
            </div>
          </>
        }
      </section>
      {showdetails ? (
        <Showdetailspopup
          data={details}
          Closebtn={Closepopup}
          silverIcon={props.silverIcon}
          goldenIcon={props.goldenIcon}
        />
      ) : null}
    </>
  );
}

export default Layout9;
